import { gql } from "@apollo/client";

export const exchangeRateList = gql`
  query ExchangeRateList {
    exchangeRates {
      id
      currencyCode
      exchangeRate
      created
      updated
    }
  }
`;

export const exchangeRateDetails = gql`
  query ExchangeRateDetails($id: ID!) {
    exchangeRate(id: $id) {
      id
      currencyCode
      exchangeRate
      created
      updated
    }
  }
`;
